import {ComponentStore} from '@ngrx/component-store';
import {ReportTableRowParametersMetricState} from './report-table-row-parameters-metric';
import {Injectable} from '@angular/core';
import {Observable, switchMap, withLatestFrom} from 'rxjs';
import {MetricComponentObject, MetricComponentObjects} from '../../../../../../shared/classes/metric-component-object';
import {AppState} from '../../../../../../shared/store/store';
import {Store} from '@ngrx/store';
import {filter, tap} from 'rxjs/operators';
import {selectMetricComponentObjects, selectMetricsLoaded} from '../../../../../../shared/store/selectors';

@Injectable()
export class ReportTableRowParametersMetricStore extends ComponentStore<ReportTableRowParametersMetricState> {
  public readonly metric$: Observable<MetricComponentObject> = this.select((state: ReportTableRowParametersMetricState): MetricComponentObject => state.metric);

  private readonly _init: (slug: string) => void = this.effect((params$: Observable<string>): Observable<[boolean, MetricComponentObjects]> => params$.pipe(
    switchMap((slug: string): Observable<[boolean, MetricComponentObjects]> => this._store.select(selectMetricsLoaded)
      .pipe(
        filter((loaded: boolean): boolean => loaded),
        withLatestFrom(this._store.select(selectMetricComponentObjects)),
        tap(([_, metrics]: [boolean, MetricComponentObjects]): void => {
          this.patchState({
            metric: metrics.find((metric: MetricComponentObject): boolean => metric.payload.attributes.slug === slug)
          })
        })
      )),
  ));

  constructor(
    private readonly _store: Store<AppState>
  ) {
    super({
      metric: null
    });
  }

  public init(slug: string): void {
    this._init(slug);
  }

}
